export default "__VITE_ASSET__kFnTC80o__"